module.exports = __webpack_public_path__ + "img/1.670a8c34.png";